import { Form, Select } from "antd";
import FilterLabel from "components/FilterLabel/FilterLabel";
import React from "react";

interface FormItemMultipleTextProps {
  id: string;
  label: string;
  onChange: (value: string[]) => void;
  value?: string[];
}

export const FormItemMultipleText = ({
  id,
  label,
  onChange,
  value,
}: FormItemMultipleTextProps) => (
  <Form.Item label={<FilterLabel text={label} htmlFor={id} />}>
    <Select<string[]>
      id={id}
      mode="tags"
      onChange={onChange}
      tokenSeparators={[",", " "]}
      value={value}
    />
  </Form.Item>
);
